<template>
    <div class="form-image" @drop.prevent="dropFile" @dragover.prevent="drag = true" :class="{drop:drag}" @dragleave.prevent="drag = false" @dragenter.prevent="drag = true">
        <label v-if="label !== ''">{{ label }} <span v-if="required" class="required">*</span></label>
        <div class="input" :class="state">
            <input type="file" style="display:none;" ref="file" @change="onFileChange">
            <div class="image" v-if="isImage()">
                <img :src="thisCurrentImage"/>
            </div>
            <div class="video" v-if="isVideo()">
                <video controls>
                    <source :src="thisCurrentImage"/>
                </video>
            </div>
            <div class="upload" v-if="inUpload">
                <div class="content">
                    <div class="title-h2">Upload... ({{uploadValue}}%)</div>
                    <div class="bar" :style="'width:'+uploadValue+'%'"></div>
                </div>
            </div>
            <div class="buttons">
                <btn square color="success" no-interaction v-if="state === 'success'">
                    <i class="fal fa-check"></i>
                </btn>
                <btn class="weight" v-if="imageSize !== ''">
                    {{ imageSize }}
                </btn>
                <btn square color="danger" no-interaction v-if="state === 'error'">
                    <i class="fal fa-times"></i>
                </btn>
                <btn square remove @click="remove" v-if="currentImage !== false && !required">
                    <tooltip :text="$t('Remove picture')" delay="0.5s">
                        <i class="fal fa-trash"></i>
                    </tooltip>
                </btn>
                <btn square @click="$refs.file.click()">
                    <tooltip :text="$t('Choose picture')" delay="0.5s" position="left">
                        <i class="fal fa-edit"></i>
                    </tooltip>
                </btn>
            </div>
        </div>
    </div>
</template>

<script>
import Btn from "@/modules/buttons/btn";
import upload from "@/class/upload";
import tools from "@/class/tools";
import Tooltip from "@/modules/tooltip";
import {Media} from "@/class/data-type";
export default {
    name: "input-media",
    components: {Tooltip, Btn},
    model:{
        prop:'image',
        event:'change'
    },
    props:{
        label:String,
        image:{type:Object, default:() => new Media()},
        storieId:Number,
        required:Boolean,
    },
    data(){
        return {
            inUpload:false,
            currentImage:false,
            currentImageSize:0,
            uploadValue:0,
            state:"",
            drag:false,
        }
    },
    methods:{
        remove(){
            return this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('Confirm'),
                text: this.$t("Do you really want to remove this image ?"),
                acceptText:this.$t('Yes, remove it'),
                cancelText:this.$t('No'),
                accept: this.removeConfirm
            })
        },
        removeConfirm() {
            this.currentImage = false;
            this.currentImageSize = 0;
            this.state = ""
            this.$emit("change",new Media({type:this.image.type, delete:true}));
        },
        dropFile(e){
            let droppedFiles = e.dataTransfer.files;
            this.drag = false;
            if(!droppedFiles) return;
    
            this.upload(droppedFiles);
    
        },
        onFileChange(e){
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            
            this.upload(files);
            
        },
        upload(files){
            
            let reader = new FileReader();
    
            reader.onload = (e) => {
        
                this.currentImage = e.target.result;
                this.currentImageSize = files[0].size;
                this.inUpload = true;
                this.uploadValue = 0;
                this.state = "upload";
        
                upload.file(files[0],this.storieId,(pct) => {
                    this.uploadValue = pct.toFixed(1);
                })
                    .then((response) => {
                        
                        let newImg = new Media({
                            id:response.id,
                            url:response.media,
                            size:this.currentImageSize,
                            type:this.image.type
                        })
                        
                        console.log(newImg)
                        this.$emit("change",newImg);
                        this.currentImage = newImg.media;
                        this.inUpload = false;
                        this.state = "success";
                        this.uploadValue = 0
                        setTimeout(() => {
                            this.state = ""
                        },5000)
                    })
                    .catch(() => {
                        this.inUpload = false;
                        this.currentImage = false
                        this.state = "error";
                        this.currentImageSize = 0;
                    })
            };
    
            reader.readAsDataURL(files[0]);
        },
        isImage(){
            return this.extension === "" || ["jpeg","jpg","png","gif"].includes(this.extension)
        },
        isVideo(){
            return ["mp4"].includes(this.extension)
        },
        isText(){
            return ["txt"].includes(this.extension)
        }
    },
    computed:{
        thisCurrentImage(){
            if(this.currentImage !== false) {
                return this.currentImage;
            }
            return this.$store.state.defaults.defaultBaseImage;
        },
        imageSize(){
            if(this.currentImageSize === 0){
                return "";
            }
            return tools.sizeToString(this.currentImageSize);
        },
        extension(){
            if(this.currentImage === false){
                return "";
            }
            if(this.currentImage.length > 255){
                return this.currentImage.split(';')[0].split('/')[1];
            }
            let split = this.currentImage.split(".");
            return split[split.length-1].toLowerCase();
        }
    },
    watch:{
        'image.media'() {
            if(this.image.hasMedia()) {
                this.currentImage = this.image.getMediaUrl();
            }
            this.currentImageSize = this.image.size;
        }
    },
    mounted() {
        if(this.image.hasMedia()) {
            this.currentImage = this.image.getMediaUrl();
        }
        this.currentImageSize = this.image.size;
    }
}
</script>
